// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMwz","title":"styles_title__1lxgS"};